import { render, staticRenderFns } from "./FamilyHistoryIcon.vue?vue&type=template&id=039f576a&"
import script from "./FamilyHistoryIcon.vue?vue&type=script&lang=js&"
export * from "./FamilyHistoryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports